<div class="pt-4 pl-md-4" *ngIf="!accountService.getMyAccount().can_manage_members">
  <h2>You do not have permission to manage this inbox.</h2>
</div>

<div class="pt-4 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-4 pl-md-4 mb-6">
  <div class="row">
    <div class="col">
      <p class="text-center w-100"><b>
        Memberships Pending Staff Approval
        <span *ngIf="inboxItems">({{ inboxItems.length }})</span>
      </b></p>
    </div>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table">

      <thead>
      <tr>
        <th scope="col">Purchase Date</th>
        <th scope="col">Owner</th>
        <th scope="col">Membership Name</th>
        <th scope="col">Status</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingInboxItems && inboxItemsPresent()">
      <tr *ngFor="let inboxItem of inboxItems">
        <td>
          {{ dateStringFromISO8601(inboxItem.purchased_at) }}
        </td>
        <td>
          <a [routerLink]="['/customers', inboxItem.owner_id.toString(), 'memberships-and-passes']" target="_blank">
            {{ inboxItem.owner_first_name }} {{ inboxItem.owner_last_name }}
          </a>
        </td>
        <td>{{ inboxItem.membership_name }}</td>
        <td><app-membership-status-badge [status]="inboxItem.status"></app-membership-status-badge></td>
        <td class="table-btn-sm text-right">
          <button class="btn btn-outline-primary btn-sm" style="min-width: 120px"
                  (click)="openReviewInboxItemModal(inboxItem);$event.preventDefault();">
            Review
          </button>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingInboxItems || !inboxItemsPresent()">
      <tr>
        <td colspan="99" *ngIf="loadingInboxItems">
          Loading...
        </td>
        <td colspan="99" *ngIf="!loadingInboxItems && !inboxItemsPresent()">
          No memberships pending review.
        </td>
      </tr>
      </tbody>

    </table>
  </div>
</div>
